import React from "react";
import { AiFillGithub } from "react-icons/ai";
import { FaLinkedinIn, FaTwitter, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import { BsCodeSlash, BsArrowUpCircleFill } from "react-icons/bs";
import Logo from "./Logo";

const NAV_LINKS = [
  { label: "Home",       section: "hero"       },
  { label: "About",      section: "about"      },
  { label: "Experience", section: "experience" },
  { label: "Projects",   section: "projects"   },
  { label: "Blog",       section: "blog"       },
  { label: "Resume",     section: "resume"     },
  { label: "Contact",    section: "contact"    },
];

const SOCIALS = [
  {
    icon: <AiFillGithub />,
    href: "https://github.com/MuhammadMuaaz007",
    label: "GitHub",
    color: "#ffffff",
  },
  {
    icon: <FaLinkedinIn />,
    href: "https://www.linkedin.com/in/muhammad-muaaz-120237297/",
    label: "LinkedIn",
    color: "#0a66c2",
  },
  {
    icon: <FaTwitter />,
    href: "https://x.com/MrMuaaz10/",
    label: "Twitter / X",
    color: "#1da1f2",
  },
];

function scrollTo(id) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
}

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer-root">
      {/* ── Top accent line ── */}
      <div className="footer-top-line" />

      <div className="footer-main">
        <div className="footer-inner">

          {/* ── Col 1: Brand ── */}
          <div className="footer-brand-col">
            <button
              className="footer-logo-btn"
              onClick={() => scrollTo("hero")}
              aria-label="Back to top"
            >
              <Logo size={44} className="footer-logo-img" />
              <span className="footer-logo-text">
                <span className="footer-logo-m">M</span>
                <span className="footer-logo-dot">.</span>
                <span className="footer-logo-m">Muaaz</span>
              </span>
            </button>

            <p className="footer-brand-desc">
              Full-Stack Developer crafting fast, scalable, and beautiful web
              experiences with React, Node.js, and modern tooling.
            </p>

            {/* Social icons */}
            <div className="footer-socials">
              {SOCIALS.map(({ icon, href, label, color }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={label}
                  className="footer-social-icon"
                  style={{ "--social-color": color }}
                >
                  {icon}
                </a>
              ))}
            </div>
          </div>

          {/* ── Col 2: Quick Links ── */}
          <div className="footer-links-col">
            <h4 className="footer-col-heading">Quick Links</h4>
            <ul className="footer-links-list">
              {NAV_LINKS.map(({ label, section }) => (
                <li key={section}>
                  <button
                    className="footer-nav-link"
                    onClick={() => scrollTo(section)}
                  >
                    <span className="footer-link-arrow">›</span>
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* ── Col 3: Contact ── */}
          <div className="footer-contact-col">
            <h4 className="footer-col-heading">Get In Touch</h4>
            <div className="footer-contact-list">
              <a
                href="mailto:mrmuaaz31@gmail.com"
                className="footer-contact-item"
              >
                <span className="footer-contact-icon"><FaEnvelope /></span>
                mrmuaaz31@gmail.com
              </a>
              <div className="footer-contact-item">
                <span className="footer-contact-icon"><FaMapMarkerAlt /></span>
                Lahore, Punjab, Pakistan
              </div>
              <a
                href="https://github.com/MuhammadMuaaz007"
                target="_blank"
                rel="noreferrer"
                className="footer-contact-item"
              >
                <span className="footer-contact-icon"><AiFillGithub /></span>
                github.com/MuhammadMuaaz007
              </a>
              <a
                href="https://www.linkedin.com/in/muhammad-muaaz-120237297/"
                target="_blank"
                rel="noreferrer"
                className="footer-contact-item"
              >
                <span className="footer-contact-icon"><FaLinkedinIn /></span>
                linkedin.com/in/muhammad-muaaz
              </a>
            </div>
          </div>

        </div>
      </div>

      {/* ── Bottom bar ── */}
      <div className="footer-bottom">
        <div className="footer-bottom-inner">
          <span className="footer-copy">
            <BsCodeSlash className="footer-copy-icon" />
            © {year} Muhammad Muaaz — Designed &amp; built with care
          </span>
          <button
            className="footer-back-top"
            onClick={() => scrollTo("hero")}
            aria-label="Scroll to top"
          >
            <BsArrowUpCircleFill />
            Back to top
          </button>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
